import { SearchType } from 'app/constants';

import { SearchFieldValue } from './types';

export const searchTypeOptions = [
    {
        value: SearchType.elastic,
        label: { short: 'Basic', long: 'Basic search' }
    },
    {
        value: SearchType.simple,
        label: { short: 'Lucene', long: 'Lucene search' }
    },
    {
        value: SearchType.product,
        label: { short: 'Product', long: 'Search by product' }
    }
] as const;

export const optionByValue = searchTypeOptions.reduce(
    (acc, option) => ({ ...acc, [option.value]: option }),
    {} as Record<SearchType, (typeof searchTypeOptions)[number]>
);

export const defaultSearchBarValue: SearchFieldValue = {
    type: SearchType.elastic,
    query: '',
    software: '',
    version: ''
};

export const defaultSimpleSearchSuggestions = [
    'type',
    'published',
    'lastseen',
    'modified',
    'title',
    'bounty',
    'cpe',
    'order',
    'cvss.score'
];
